// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useMutation } from '@tanstack/react-query'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'

export function useExchangeFinchAuthorizationCodeForToken () {
  return useMutation<{ success: boolean }, GrapeAPIErrorType, { code: string }>({
    mutationFn: async ({ code }: { code: string }) => {
      const request = new FetchRequest(
        'post',
        '/api/web/payroll/finch/exchange_authorization_code',
        {
          body: { code },
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return { success: true }
    },
  })
}
